module.exports = __webpack_public_path__ + "static/scale-model-of-new-riff-distilling-in-cincinnati-ohio-8c35540a10a04a1043df905522ed6d84.png";